import { animate } from 'animejs';

export default function ModalInit () {
  new Modal()
}

class Modal {

  constructor () {
    this.body = document.body
    this.closing = false

    const closeBtns = document.querySelectorAll('.modal-outer .close-modal')
    const openBtns = document.querySelectorAll('.open-modal')

    for (let i = 0; i < openBtns.length; i++) {
      const open = openBtns[i]

      // Open modal on button close
      open.addEventListener('click', (e) => {
        e.preventDefault()
        const modalID = open.getAttribute('data-id')
        this.openModal(document.querySelectorAll('div[data-id="'+modalID+'"]')[0])
      })
    }

    // Close buttons
    for (let i = 0; i < closeBtns.length; i++) {
      const close = closeBtns[i]
      const modal = this.getClosest(closeBtns[i], '.modal-outer')

      // close modal on button close
      close.addEventListener('click', () => {
        this.closeModal()
      })

      // close modal on when clicking outside modal
      modal.addEventListener('click', (e) => {
        if (e.target.classList.contains('modal-outer')) {
          this.closeModal()
        }
      })
    }

    // close modal on escape
    document.onkeydown = function (evt) {
      evt = evt || window.event

      if (evt.keyCode === 27 && this.body.classList.contains('modal-open')) {
        this.closeModal()
      }
    }.bind(this)

    window.closeModal = this.closeModal // Make method available in global scope
    window.openModal = this.openModal // Make method available in global scope
    window.getClosest = this.getClosest // Make method available in global scope
  }

  // Find closest element by class
  getClosest (elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
      Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector ||
        function (s) {
          const matches = (this.document || this.ownerDocument).querySelectorAll(s)
          let i = matches.length
          while (--i >= 0 && matches.item(i) !== this) {}
          return i > -1
        }
    }

    // Get the closest matching element
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(selector)) return elem
    }
    return null
  }

  openModal (modal) {
    animate(modal.children[0], {
      opacity: [0, 1],
      translateY: [-30, 0],
      duration: 300,
      ease: 'outCubic',
      delay: 200
    })

    this.body.classList.add('modal-open')
    jQuery(this.body).find('.gform_wrapper').show()
    modal.classList.add('active')
  }

  closeModal () {
    if (this.closing) return false

    this.closing = true

    setTimeout(() => {
      this.closing = false
    }, 1000)

    const modal = document.querySelector('.modal-outer.active')

    this.body.classList.remove('modal-open')

    animate('.modal-inner', {
      opacity: [1, 0],
      translateY: [0, -30],
      duration: 300,
      ease: 'outCubic'
    })

    setTimeout(function () {
      modal.classList.remove('active')
    }, 300)

    const modalevent = document.createEvent('Event')
    modalevent.initEvent('modalclosed', true, true)
    modal.dispatchEvent(modalevent)
  }
}